import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IChatAgentChatMetadata } from '@sharedInterfaces/ChatAgent';

interface ChatAgentState {
    chatList: IChatAgentChatMetadata[];
    isLoading: boolean;
}

const initialState: ChatAgentState = {
    chatList: [],
    isLoading: false,
};

const chatAgentSlice = createSlice({
    name: 'chatAgent',
    initialState,
    reducers: {
        setChatList: (state, action: PayloadAction<IChatAgentChatMetadata[]>) => {
            state.chatList = action.payload;
        },
        updateChatTitle: (state, action: PayloadAction<{ chatId: string; title: string }>) => {
            const chat = state.chatList.find((c) => c.chatId === action.payload.chatId);
            if (chat) {
                chat.title = action.payload.title;
            }
        },
        addNewChat: (state, action: PayloadAction<IChatAgentChatMetadata>) => {
            // Only add if chat doesn't already exist
            const exists = state.chatList.some((chat) => chat.chatId === action.payload.chatId);
            if (!exists) {
                state.chatList.unshift(action.payload);
            }
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
    },
});

export const { setChatList, updateChatTitle, addNewChat, setLoading } = chatAgentSlice.actions;
export default chatAgentSlice.reducer;
